import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-element-context-menu',
  templateUrl: './element-context-menu.component.html',
  styleUrl: './element-context-menu.component.scss'
})
export class ElementContextMenuComponent {
  @Output() manage = new EventEmitter();
  @Output() moveUp = new EventEmitter();
  @Output() moveDown = new EventEmitter();
  @Output() remove = new EventEmitter();

  @Input() hasEntries: boolean = false;
  @Input() elementId: string;
}
